import VideoTestPage from './VideoTestPage';

export default VideoTestPage;
